import React from 'react'
import {BlogDetails} from "../components/blog/BlogDetails";


export const BlogDetailsPage = () => {
  return (
    <BlogDetails/>
  )
}
